/* eslint-disable react/prop-types */
import React, { useContext } from "react";
import { Box, Button, TableCell, TableRow } from "@mui/material";
import Flag from "@mui/icons-material/FlagOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import * as Sentry from "@sentry/react";
import { tabelCellWidth, style } from "./styles";
import Typography from "../common/new/Typography/Typography";
import { isEmptyObj } from "../../utils/helper";
import Gohonzon from "../../services/api/gohonzon";
import { ToastAlertContext } from "../../config/providers/ToastAlert";
import { AlertStatus } from "../../contants";

const BLOCK_DIVISION_IDS = [52, 53];

const canApply = (member, gohonzonType) => {
  const alreadyApplied = member?.gohonzonMemberships?.some(
    (item) => item.type === gohonzonType
  );

  const { familyGohonzons } = member || {};

  const blockByDivision = BLOCK_DIVISION_IDS.includes(
    Number(member.divisionId)
  );

  if (alreadyApplied) {
    return [true, "Member already has Gohozon"];
  }
  if (
    familyGohonzons &&
    familyGohonzons?.length &&
    gohonzonType === "OKATAKI_GOHONZON"
  ) {
    return [true, "Existing Family Gohonzon"];
  }
  if (blockByDivision) {
    return [true, "Future division is not eligible to apply"];
  }
  return [false, ""];
};

function GohonzonApply({ member, gohonzonType, onMemberSelect }) {
  if (isEmptyObj(member)) {
    return null;
  }

  console.log("gohonzonType", gohonzonType);

  const [block, blockMessage] = canApply(member, gohonzonType);
  const toast = useContext(ToastAlertContext);

  const memberEligibility = async () => {
    try {
      const response = await Gohonzon.GohonzonApplyEligibility(
        { gohonzonType },
        member.memberId
      );
      if (response.message === "eligible") {
        onMemberSelect(member.memberId, response.message);
      }
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);

      Sentry.captureException(error);
    }
  };

  const handleApplyClick = () => {
    memberEligibility(); // Call the API when the "Apply" button is clicked
  };

  return (
    <TableRow style={style.tableRow}>
      <TableCell style={style.rowStyle}>
        <Flag htmlColor={block ? "#FF6A69" : "#8C8C8C"} />
      </TableCell>
      <TableCell style={{ ...style.rowStyleId, ...tabelCellWidth.tiny }}>
        {member.memberId}
      </TableCell>
      <TableCell style={{ ...style.rowStyle, ...tabelCellWidth.small }}>
        <Typography style={style.typogrphyStyle}>{member.fullName} </Typography>
        <br /> <br />
        <Typography style={style.typogrphyStyle}>
          {member.addressLine1}
        </Typography>
      </TableCell>
      <TableCell style={{ ...style.rowStyle, ...tabelCellWidth.small }}>
        <Typography style={style.typogrphyStyle}>
          {member.mobileNumber || "-"}
        </Typography>
        <br /> <br />
        <Typography style={style.typogrphyStyle}>{member.emailId}</Typography>
      </TableCell>
      <TableCell style={style.rowStyle}>
        <Typography style={style.typogrphyStyle}>
          {member.divisionName || "-"}
        </Typography>
      </TableCell>
      <TableCell style={style.rowStyle}>
        <Typography style={style.typogrphyStyle}>
          {member?.blockName ?? ""}
        </Typography>
        {block && (
          <>
            <br />
            <div style={style.rowStyleInfo}>
              <Box style={style.existingGZ}>
                <InfoOutlinedIcon fontSize="small" htmlColor="#FF0100" />{" "}
                <Typography variant="mini" color="#FF0100">
                  {blockMessage}
                </Typography>
              </Box>
            </div>
          </>
        )}
      </TableCell>
      <TableCell style={tabelCellWidth.small}>
        <Button
          disabled={block}
          style={block ? style.disableButton : style.applyButton}
          // onClick={() => onMemberSelect(member.memberId)}
          onClick={() => handleApplyClick()}
        >
          APPLY
        </Button>
      </TableCell>
    </TableRow>
  );
}

export default GohonzonApply;
